@if ({ saved: saved$ | async, tooltipPosition: tooltipPosition$ | async }; as comp) {
  <div class="save-btn-container">
    @if (loading$ | async) {
      <p-progressSpinner [style]="{ height: '36px', width: '36px' }" class="spinner" />
    }
    <button
      pButton
      pRipple
      class="save-button"
      styleClass="test-style-class"
      [icon]="'pi ' + (comp.saved ? 'pi-heart-fill' : 'pi-heart')"
      [ngStyle]="{ color: comp.saved ? '#db3747' : '#57585b' }"
      (click)="updateStatus($event)"
      pTooltip="Save property"
      [tooltipPosition]="comp.tooltipPosition || 'right'"></button>
  </div>
}
